import type { LiteralUnion } from "type-fest";

export type SummaryResolution = LiteralUnion<"resolved" | "not resolved" | "transferred", string> | null;
